module.exports = __webpack_public_path__ + "img/index-third.e85db37.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/index-third.jpg
// module id = ./assets/images/index-third.jpg
// module chunks = 2